export const CONFIGURACION_API_KEY_MODULE_ID = 'configuracion_api_key'

export const ROLES_DEFAULT_CONFIGURACION_API_KEY = [
  'ADMIN',
  'COLABORADOR',
  'SUPER_COLABORADOR',
  'DPO',
]

export function defaultConfiguracionApiKeyAccess(roles) {
  return (roles || []).some((r) => ROLES_DEFAULT_CONFIGURACION_API_KEY.includes(r))
}
